const SUBSCRIPTION_REQUIRED_KEY = 'subscriptionRequired';

const getToken = () => {
  return window.localStorage.getItem('authToken') || '';
};

const setToken = (token: string) => {
  window.localStorage.setItem('authToken', token);
  window.localStorage.removeItem('EUAuthToken');
};

const removeToken = () => {
  window.localStorage.removeItem('authToken');
  window.localStorage.removeItem(SUBSCRIPTION_REQUIRED_KEY);
};

const setSubscriptionRequired = (required: boolean) => {
  if (required) {
    window.localStorage.setItem(SUBSCRIPTION_REQUIRED_KEY, 'true');
  } else {
    window.localStorage.removeItem(SUBSCRIPTION_REQUIRED_KEY);
  }
};

const isSubscriptionRequired = () => {
  return window.localStorage.getItem(SUBSCRIPTION_REQUIRED_KEY) === 'true';
};

const isAuthenticated = () => {
  return !['', null].includes(getToken());
};

export {
  getToken,
  setToken,
  removeToken,
  setSubscriptionRequired,
  isSubscriptionRequired,
  isAuthenticated,
};
